// src/utils/excelExport.js
import * as XLSX from 'xlsx';

/**
 * Genera y descarga un archivo Excel
 * @param {Array} data - Datos a exportar (array de objetos)
 * @param {String} fileName - Nombre del archivo (sin extensión)
 * @param {String} sheetName - Nombre de la hoja (opcional)
 */
export function exportToExcel(data, fileName = 'export', sheetName = 'Datos') {
  // Crear un libro de trabajo
  const wb = XLSX.utils.book_new();
  
  // Convertir los datos a una hoja de trabajo
  const ws = XLSX.utils.json_to_sheet(data);
  
  // Añadir la hoja al libro
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  
  // Generar el archivo Excel como array buffer
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  
  // Crear blob y descargar
  const blob = new Blob([wbout], { type: 'application/octet-stream' });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.xlsx`;
  document.body.appendChild(link);
  link.click();
  
  // Limpieza
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 100);
}

